import typeErrorsUI from './typeErrorsUI.js';
import { validateTypes } from 'pro-gallery-lib';

const validate = validateTypes;
export { validate, typeErrorsUI };
